import styled from "@emotion/styled";
import ReactFullpage from "@fullpage/react-fullpage";
import { useRef, useState } from "react";
import ThreeScene from "../shared/ThreeScene";
import useStore from "../shared/useStore";
import About from "./About";
import Contact from "./Contact";
import Header from "./Header";
import Navigation from "./Navigation";
import Projects from "./Projects";
import QrCode from "./QrCode";
import Skills from "./Skills";

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 1;
  transition: 1000ms;
  display: none;
  @media (${(props) => props.theme.breakpoint}) {
    display: block;
  }
`;

const Fade = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #000;
  isolation: isolate;
  z-index: 9999;
  opacity: 0;
  pointer-events: none;
`;

const Noise = styled.div`
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.6;
  background-image: url(data:image/png;base64,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);
`;

const sectionsCount = 4;

const Content = () => {
  const fadeEffect = useRef();
  const backdropRef = useRef();
  const isAnimated = useRef(false);
  const [isOpen, setIsOpen] = useState(false);
  const [oldSection, setOldSection] = useState();

  const currentSection = useStore((state) => state.currentSection);
  const updateCurrentSection = useStore((state) => state.updateCurrentSection);

  const makeFadeEffect = (destinationIndex) => {
    const $fadeEffect = fadeEffect.current;
    const $backdrop = backdropRef.current;
    $fadeEffect.style.animation = "none";
    $backdrop.style.animation = "none";
    // eslint-disable-next-line no-unused-expressions
    $fadeEffect.offsetHeight;
    $backdrop.style.animation = "fadeIn 800ms 1000ms forwards";
    $fadeEffect.style.animation = "fade 1800ms forwards";

    isAnimated.current = true;

    setTimeout(() => {
      updateCurrentSection(destinationIndex);
    }, 500);

    setTimeout(() => {
      isAnimated.current = false;
    }, 1800);
  };

  const triggerFadeEffect = (origin, destination) => {
    if (isAnimated.current) {
      return false;
    }
    const destinationIndex = destination.index;
    makeFadeEffect(destinationIndex);
  };

  const handleClick = () => {
    if (isOpen) {
      makeFadeEffect(oldSection);
      setIsOpen(false);
    } else {
      makeFadeEffect(sectionsCount);
      setOldSection(currentSection);
      setIsOpen(true);
    }
  };

  const moveTo = async (destinationIndex) => {
    if (destinationIndex !== oldSection) {
      window.fullpage_api.silentMoveTo(destinationIndex + 1);
    } else {
      makeFadeEffect(oldSection);
    }
    setIsOpen(false);
  };

  return (
    <>
      <ThreeScene currentSection={currentSection} />
      <Noise />
      <Backdrop ref={backdropRef} />
      <Fade ref={fadeEffect} />
      <Header currentSection={currentSection} onClick={handleClick} />
      {currentSection === sectionsCount && <Navigation onClick={moveTo} />}
      <ReactFullpage
        licenseKey={"YOUR_KEY_HERE"}
        scrollingSpeed={100}
        onLeave={triggerFadeEffect}
        render={() => {
          return (
            <ReactFullpage.Wrapper>
              <div className="section">
                <About visible={currentSection === 0} />
              </div>
              <div className="section">
                <Skills visible={currentSection === 1} />
              </div>
              <div className="section">
                <Projects visible={currentSection === 2} />
              </div>
              <div className="section">
                <Contact visible={currentSection === 3} />
              </div>
            </ReactFullpage.Wrapper>
          );
        }}
      />
    </>
  );
};

const Main = () => {
  return (
    <>
      <Content />
      <QrCode />
    </>
  );
};

export default Main;
